/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/lib/utils/DefaultCompanyDataProvider"/>

import { CompanyDataProvider } from "Core/Medius.Core.Web/Scripts/Medius/components/editors/autocompleter/company/dataProvider";
import * as _ from "underscore";
import {ajax} from "Core/Medius.Core.Web/Scripts/Medius/core/rpc";
import * as backendErrorHandler from "Core/Medius.Core.Web/Scripts/Medius/core/backendErrorHandler";
import * as serialization from "Core/Medius.Core.Web/Scripts/Medius/lib/serialization";

export class Provider extends CompanyDataProvider {
    availableCompaniesIds: any = null;

    filterByAvailableCompanies(data: any) {
        return this.filter(data, (company: any) => {
            return _.contains(this.availableCompaniesIds, company.Id);
        });
    }

    getResults(userId: number) {
        return ajax('UserService','GetAvailableDefaultCompaniesIds', {
                    data: serialization.toJSON({userId: userId})
                }).done((data: any) => {
                    this.availableCompaniesIds = data;
                }).fail((xhr:any) => {
                    backendErrorHandler.handleAnyError(xhr);
                });
    }

    search(searchText: string, maxResults: number, offset: number, options: any) {
        const resultHandler = super.search(searchText, maxResults, offset, options)
            .pipe((data) => {
                return this.filterByAvailableCompanies(data);
            });

        return resultHandler;
    }
}